import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=616a1e54&"
import script from "./AboutUs.vue?vue&type=script&lang=ts&"
export * from "./AboutUs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports